/**
 * @class KeyboardShortcut
 */
export default class KeyboardShortcut {
    /**
     * @param {String}  name
     * @param {Number}  keyCode
     * @param {Boolean} shift
     * @param {Boolean} ctrl
     * @param {Boolean} active
     */
    constructor(name, keyCode, shift, ctrl, active) {
        this._name = name;
        this._keyCode = keyCode;
        this._shift = shift;
        this._ctrl = ctrl;
        this._active = active;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {Number}
     */
    get keyCode() {
        return this._keyCode;
    }

    /**
     * @param {Number} keyCode
     */
    set keyCode(keyCode) {
        this._keyCode = keyCode;
    }

    /**
     * @return {Boolean}
     */
    get shift() {
        return this._shift;
    }

    /**
     * @param {Boolean} shift
     */
    set shift(shift) {
        this._shift = shift;
    }

    /**
     * @return {Boolean}
     */
    get ctrl() {
        return this._ctrl;
    }

    /**
     * @param {Boolean} ctrl
     */
    set ctrl(ctrl) {
        this._ctrl = ctrl;
    }

    /**
     * @return {Boolean}
     */
    get active() {
        return this._active;
    }

    /**
     * @param {Boolean} active
     */
    set active(active) {
        this._active = active;
    }

    /**
     * Compares keyboard shortcut object with event from keyboard
     *
     * @param   {Object} event
     * @return  {Boolean}
     */
    equals = (event) => {
        return (
            this._active &&
            this._keyCode === event.keyCode &&
            this._shift === event.shiftKey &&
            this._ctrl === event.ctrlKey
        );
    };
}
